<template>
    <div>
        <input
                v-show="!importInProgress"
                type="file"
                :ref="reference"
                name="importFile"
                class="form-control-file d-none"
                v-on:change="importFile()"
        >
        <button
                class="btn btn-custom"
                @click="$refs[reference].click()"
        >
            Importer
        </button>
        <div
                class="loader-inner ball-clip-rotate px-4"
                :style="{background: mergedCss.import.background, 'border-radius': mergedCss.import['border-radius'] }"
                v-show="importInProgress"
        >
            <span class="mr-3">{{ mergedText.modal.import_in_progress }}</span>
            <div :style="{border: mergedCss.loader.border, 'border-bottom-color': mergedCss.loader['border-bottom-color'] }"></div>
        </div>

        <modal
                name="table"
                class="modal-import"
                scrollable
                resizable
                draggable
                :style="{background: mergedCss.modal.overlay}"
        >
            <div class="p-4">
                <div class="modal-import-select-container">
                    <div>
                        <label for="eol">{{ mergedText.modal.end_of_line }}</label>
                        <select v-model="eol" name="eol" id="eol">
                            <option v-for="e in eols" :value="e">
                                {{e.replace('\n','\\n').replace('\r','\\r').replace('\t','\\t')}}
                            </option>
                        </select>
                    </div>
                    <div class="ml-4">
                        <label for="delimiter" :style="{color: mergedCss.modal.color}">
                            {{ mergedText.modal.separator }}
                        </label>
                        <select v-model="delimiter" name="delimiter" id="delimiter">
                            <option
                                    v-for="d in delimiters"
                                    :value="d"
                            >
                                {{d.replace('\n','\\n').replace('\r','\\r').replace('\t','\\t')}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="modal-import-error">
                    <p>
                        {{ error }}
                    </p>
                </div>

                <div class="mt-4">
                    <h4 class="mb-3">{{ mergedText.modal.preview_title }}</h4>
                    <div class="table-scrollable">
                        <table class="table table-striped table-bordered table-hover" v-if="rows.length > 0">
                            <tbody>
                            <tr v-for="row in rows">
                                <td v-for="cell in row">
                                    {{
                                    (typeof cell == 'string') ?
                                    cell.replace(/^[\s\uFEFF\xA0"]+|[\s\uFEFF\xA0"]+$/g, ''):
                                    cell
                                    }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-else>
                            Aucune donnée
                        </div>

                        <div class="modal-import-footer mt-4">
                            <button class="btn btn-custom" @click="sendFile()"
                                    :style="{ background: mergedCss.modal.cancelButton.background, 'border-color': mergedCss.modal.cancelButton['border-color'], color: mergedCss.modal.cancelButton.color }">
                                {{ mergedText.modal.import }}
                            </button>
                            <button class="btn btn-outline ml-3" @click="$modal.hide('table')"
                                    :style="{ background: mergedCss.modal.importButton.background, 'border-color': mergedCss.modal.importButton['border-color'], color: mergedCss.modal.importButton.color }">
                                {{ mergedText.modal.cancel }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import swal from 'sweetalert2';
    import parse from 'csv-parse/lib/sync';
    import merge from 'lodash/merge';
    import axios from 'axios';

    export default {
        name: "ImportCsv",
        data() {
            return {
                importInProgress: false,
                file: null,
                showModal: false,
                eol: '\n',
                delimiter: ',',
                eols: ['\n', '\r', '\r\n', '\n\r'],
                delimiters: [',', ';', ' '],
                rows: [],
                error: '',

                // Custom styles & texts
                defaultText: {
                    swal: {
                        success: {
                            title: "Succès",
                            text: "Importation du fichier réussi."
                        },
                        error: {
                            title: "Oops",
                            text: "Importation du fichier impossible."
                        },
                        emptyFile: {
                            title: "Oops...",
                            text: "Le fichier est vide !",
                        }
                    },
                    modal: {
                        cancel: "Annuler",
                        import: "Importer",
                        preview_title: "Aperçu des premières lignes :",
                        end_of_line: "Fin de ligne :",
                        separator: "Séparateur :",
                        import_in_progress: "Importation en cours",
                    },
                    error_message: "Erreur lors de l'analyse syntaxique.",
                },
                mergedText: {},
                defaultCss: {
                    import: {
                        background: "#fff",
                        "border-radius": "2px"
                    },
                    loader: {
                        border: "2px solid #0069d9",
                        "border-bottom-color": "transparent"
                    },
                    modal: {
                        overlay: "rgba(255, 255, 255, 0.3)",
                        colorTitle: "#333",
                        importButton: {
                            background: "#f0f0f0",
                            "border-color": "#f0f0f0",
                            color: "#000",
                        },
                        cancelButton: {
                            background: "#0069d9",
                            "border-color": "#0069d9",
                            color: "#fff",
                        },
                    }
                },
                mergedCss: {}
            }
        },
        props: {
            /**
             * Reference passed to input field
             */
            reference: {
                type: String,
                default: 'importFile',
                required: false,
            },
            /**
             * API to send file
             */
            api: {
                type: String,
                required: true,
            },
            /**
             * To override text
             */
            text: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            /**
             * To override css
             */
            css: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        methods: {
            /**
             * Import file to hydrate db
             */
            importFile() {
                // Clear les messages d'erreur
                this.clearError();

                // Stock file
                this.file = this.$refs[this.reference].files[0];

                // Show loader
                this.importInProgress = true;

                // Check if file is not empty
                this.checkEmptyFile().catch(() => {
                    // Hide loader
                    this.importInProgress = false;
                });

                // Creat efilereader
                this.createFilereader();

                // Show datatable
                this.showTable();

                // Stop import load
                this.importInProgress = false;
            },
            /**
             * Check if file is empty
             *
             * @returns {Promise<any>}
             */
            checkEmptyFile() {
                return new Promise((resolve, reject) => {
                    if (this.file.size === 0) {
                        swal({
                            type: 'error',
                            title: this.mergedText.swal.emptyFile.title,
                            text: this.mergedText.swal.emptyFile.text
                        });

                        this.$emit('emptyFile');

                        reject();
                    }

                    resolve();
                });
            },
            /**
             * Clear error
             */
            clearError() {
                this.error = '';
            },
            /**
             * Show datatable to confirm import
             */
            showTable() {
                this.$emit('showTable');
                this.$modal.show('table');
            },
            /**
             * Hide modal
             */
            hideModal() {
                this.$emit('hideTable');
                this.modal = false;
            },
            /**
             * Create filereader
             */
            createFilereader() {
                let reader = new FileReader();
                reader.onload = () => {
                    this.data = reader.result;
                    this.autodetect();
                    this.reparseCsv();
                };
                reader.readAsText(this.file);
            },
            /**
             * Detect EOL/ delimiter of file
             */
            autodetect() {
                let good_eol = '\n',
                    good_eol_count = 0;
                for (let i = 0; i < this.eols.length; i++) {
                    let c = this.count(this.data, this.eols[i]);
                    if (c > good_eol_count) {
                        good_eol = this.eols[i];
                        good_eol_count = c;
                    }
                }
                this.eol = good_eol;

                let good_delimiter = ',',
                    good_delimiter_count = 0;
                for (let i = 0; i < this.delimiters.length; i++) {
                    let e = this.delimiters[i];
                    let c = this.count(this.data, e);
                    if (c > good_delimiter_count) {
                        good_delimiter = e;
                        good_delimiter_count = c;
                    }
                }

                this.delimiter = good_delimiter;
            },
            /**
             * Count occurence number of eol
             *
             * @param file_content
             * @param eol
             * @returns {number}
             */
            count(file_content, eol) {
                let count = 0,
                    position = file_content.indexOf(eol);
                while (position > -1) {
                    count++;
                    position = file_content.indexOf(eol, ++position);
                }

                return count;
            },
            /**
             * Reparse CSV file
             */
            reparseCsv() {
                let index_of_last_eol = 0;
                for (var n = 0; n < 5; n++) {
                    var new_index = this.data.indexOf(this.eol, index_of_last_eol++);
                    if (new_index === -1) {
                        break;
                    }

                    index_of_last_eol = new_index;
                }
                try {
                    this.rows = parse(this.data, {
                        rowDelimiter: this.eol,
                        delimiter: this.delimiter,
                        to: 5
                    });
                } catch (e) {
                    this.$emit('errorParser');
                    this.error = this.mergedText.error_message;
                }

                this.rows = this.rows.slice(1);
            },
            /**
             * Create form data
             *
             * @returns {FormData}
             */
            createFormData() {
                // Create formData object to add file
                let formData = new FormData();

                formData.append('file', this.file);
                formData.append('eol', escape(this.eol));
                formData.append('delimiter', escape(this.delimiter));

                return formData;
            },
            /**
             * Send file to API
             */
            sendFile() {
                let formData = this.createFormData();

                axios.post(`${this.api}`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(() => {
                    swal(this.mergedText.swal.success.title, this.mergedText.swal.success.text, "success");
                }).catch(() => {
                    swal(this.mergedText.swal.error.title, this.mergedText.swal.error.text, "error");
                }).then(() => {
                    this.$modal.hide('table');
                });
            },
            /**
             * Merge default text with custom text of user
             */
            mergeText() {
                this.mergedText = merge(this.defaultText, this.text)
            },
            /**
             * Merge default css with custom css of user
             */
            mergeCss() {
                this.mergedCss = merge(this.defaultCss, this.css)
            },
        },
        created() {
            this.mergeText();
            this.mergeCss();
        },
        watch: {
            eol() {
                // Clear les messages d'erreur
                this.clearError();

                this.$emit('changeEol');

                this.reparseCsv();
            },
            delimiter() {
                // Clear les messages d'erreur
                this.clearError();

                this.$emit('changeDelimiter');

                this.reparseCsv();
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "~loaders.css/loaders.min.css";

    .ball-clip-rotate {
        display: flex;

        justify-content: center;
        align-items: center;

        background: #fff;
        border-radius: 2px;

        & > div {
            border: 2px solid #0069d9;
            border-bottom-color: transparent;
        }
    }

    .modal-import {
        .modal-import-select-container {
            display: flex;
        }

        .modal-import-error {
            p {
                color: #a80000;
                font-weight: bold;
            }
        }

        .modal-import-footer {
            display: flex;

            justify-content: end;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/layout/ImportCsv.vue